<template>
  <v-row>
    <v-col cols="12">
      <v-card>

        <v-card-title class="pb-8">
          <v-btn
            color="primary"
            @click="TOGGLE_PREORDINI_CREATE"
          >Nuovo Preordine</v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cerca"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :search="search"
          :headers="headers"
          :items="items"
          class="elevation-1"
          :items-per-page="100"
          :footer-props="{
              itemsPerPageAllText: 'Tutti',
              itemsPerPageOptions: [15, 50, 100, -1],
              itemsPerPageText: 'Preordini per pagina',
            }"
        >
          <template v-slot:top>
            <create-dialog
              :kind="kind"
              @dismiss="TOGGLE_PREORDINI_CREATE"
              @saved="refresh"
            />
            <edit-dialog
              :kind="kind"
              @dismiss="TOGGLE_PREORDINI_EDIT"
              @saved="refresh"
            />
            <delete-dialog
              :kind="kind"
              @dismiss="TOGGLE_PREORDINI_DELETE"
              @saved="refresh"
            />
          </template>

          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="_fetch"
            >Ricarica</v-btn>
          </template>

          <template v-slot:item.action="{ item }">
            <td class="actions">
              <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click.stop="update(item)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn
                color="red"
                class="ml-1"
                elevation="1"
                outlined
                small
                @click.stop="remove(item)"
              >
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </td>
          </template>

          <template v-slot:item.state="{ item }">
            <span
              v-if="item.state == 'Inserito'"
              v-text="item.state"
              class="red--text"
            ></span>
            <span
              v-if="item.state == 'Ordinato'"
              v-text="item.state"
              class="orange--text"
            ></span>
            <span
              v-if="item.state == 'Arrivato'"
              v-text="item.state"
              class="blue--text"
            ></span>
            <span
              v-if="item.state == 'Consegnato'"
              v-text="item.state"
              class="green--text"
            ></span>
          </template>

          <template v-slot:item.text="{ item }">
            <span v-if="item.device">{{item.device.text}}</span>
            <span v-else-if="item.accessory">{{item.accessory.text}}</span>
            <span v-else>{{item.replacement.text}}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  import CreateDialog from './CreateDialog.vue'
  import EditDialog from './EditDialog.vue'
  import DeleteDialog from './DeleteDialog.vue'

  export default {
    name: 'DevicesTable',

    components: {
      CreateDialog,
      EditDialog,
      DeleteDialog
    },

    data() {
      return {
        kind: null,
        search: null,
        headers: [
          { text: 'Stato', value: 'state', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Data', value: 'created_at', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Articolo', value: 'text', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Cliente', value: 'customer.fullname', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Recapito', value: 'customer.phone', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Note', value: 'description', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
        ],
        items: [],
        filteredItems: [],
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    computed: {
      ...mapGetters([
        'getPreordiniCreate',
        'getPreordiniEdit',
        'getPreordiniFiltersStatus'
      ]),

      route() {
        return this.$route.path.split('/')
      },
    },

    methods: {
      ...mapMutations([
        'SET_PREORDINI_CREATE',
        'SET_PREORDINI_EDIT',
        'SET_PREORDINI_DELETE',
        'TOGGLE_PREORDINI_CREATE',
        'TOGGLE_PREORDINI_EDIT',
        'TOGGLE_PREORDINI_DELETE',
        'SET_PREORDINI_SELECTED'
      ]),

      async _fetch() {

        let { data: preorders } = await axios.get(
          `${process.env.VUE_APP_API}/preorders/${this.kind}`,
          this.config
        )

        preorders = preorders.map(item => {

          const state = item.state.toLowerCase()
          const visible = this.getPreordiniFiltersStatus[state]

          console.log(state, visible)

          if (visible) {
            return item
          }

          return null
        }).filter(el => el != null)

        this.items = preorders
      },

      async refresh() {
        this._fetch()

        this.SET_PREORDINI_CREATE(false)
        this.SET_PREORDINI_EDIT(false)
        this.SET_PREORDINI_DELETE(false)
      },

      update(item) {
        this.SET_PREORDINI_SELECTED({ ...item })
        this.TOGGLE_PREORDINI_EDIT()
      },

      remove(item) {
        this.SET_PREORDINI_SELECTED({ ...item })
        this.TOGGLE_PREORDINI_DELETE()
      }
    },

    watch: {
      route: {
        handler(val) {
          const { length, [length - 1]: kind } = val
          this.kind = kind

          this._fetch()
        },
        immediate: true,
        deep: true
      },
      getPreordiniFiltersStatus: {
        handler(val) {
          console.log(val)
          this._fetch()
        },
        deep: true
      }
    },

    async mounted() {
      await this._fetch()
    }
  }
</script>

<style scoped>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>